module.exports = __webpack_public_path__ + "static/media/canera-bank.51e4de66.svg";